export default class CurrentUserEmpty {

    constructor(userField, documents, currentUser) {
        this.userField = userField
        this.documents = documents
        this.currentUser = currentUser
    }

    test() {
        console.log('CurrentUserEmpty.test')
        for(let i = 0; i < this.documents.length; i++) {
            let document = this.documents[i]

            if(document[this.userField.index] && document[this.userField.index].user_id === this.currentUser.id ) {
                return false
            }
        }

        return true
    }
}